import * as React from "react";
function SvgReview(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" height={32} rx={6} width={32} />
      <path
        d="M16 7.75c-6.08 0-11 2.75-11 6.19 0 1.56 1 3 2.75 4.07v6.24l4.5-4.5a18.2 18.2 0 003.75.37c6.08 0 11-2.74 11-6.18s-4.92-6.19-11-6.19zM13.66 16l-1.78-.94-1.79.94.34-2L9 12.64l2-.29.89-1.85.89 1.81 2 .29-1.45 1.4zm8.25 0l-1.79-.94-1.78.94.34-2-1.44-1.37 2-.29.88-1.85.9 1.81 2 .29L21.58 14z"
        fill="#fff"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgReview);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
